import { timeSyncInterval } from '@/utils/constants';
var timesync = require('timesync');
import logger from '@/modules/Logger';

/**
 * ===============================================
 * Time Sync with Chat Backend Server
 * ===============================================
 *
 * ts.now() - Get the synchronized time (ms)
 *
 * ===============================================
 */

let ts;

// Initialize Time Sync
const initializeTimeSync = socket => {
  ts = timesync.create({
    server: socket,
    interval: timeSyncInterval,
    timeout: 5000
  });

  // Time synchronization has started or finished
  ts.on('sync', function(state) {
    logger.info(`Time sync has ${state}ed`, { operation: 'lesson:time-sync' });
  });

  // Error occured on time sync
  ts.on('error', function(err) {
    logger.error(`Time sync encountered an error`, { operation: 'lesson:time-sync', reason: err ,event_type:33,lesson_id:this.lessonId  });
  });

  // Send time sync request to the chatserver
  ts.send = (socket, data, timeout) => {
    return new Promise(function(resolve, reject) {
      var timeoutFn = setTimeout(reject, timeout);
      if (socket) {
        socket.emit('timesync', data, () => {
          clearTimeout(timeoutFn);
          resolve();
        });
      }
    });
  };
}

// Receive time sync from Socket.io server
const receiveTimeSync = (data) => {
  ts.receive(null, data);
}

// Get the current time
const tsNow = () => {
  // Socket.io connection is establish, use the sync time, if not use local time
  return ts ? ts.now() : Date.now();
}


export { initializeTimeSync, receiveTimeSync, tsNow }
